const Portfolio = require("./containers/Portfolio");
const Authenticate = require("../utils").authenticate;

module.exports = {
    path: "/portfolio",
    component: Authenticate(Portfolio),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/portfolio/index.js